import { ServiceItem, WorkflowStep, Testimonial, Technology, StatCounter } from '../types';

export const COMPANY_INFO = {
  name: 'ASAP LEARNING',
  legalName: 'ASAP LEARNING Pvt. Ltd.',
  tagline: 'AI-Driven Publishing Solutions',
  subTagline: 'Transforming education worldwide with innovative publishing and digital solutions.',
  phone: '+91-7817899559',
  email: 'contact@asaplearning.in',
  careersEmail: 'contact@asaplearning.in',
  address: 'Dehradun, Uttarakhand 248001, INDIA',
  whatsappNumber: '917817899559',
  linkedinUrl: 'https://www.linkedin.com/company/asap-learning-global/',
  youtubeUrl: 'https://www.youtube.com/@asaplearning-global',
  mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55088.92211909831!2d78.00392945!3d30.3164945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390929c356f88883%3A0x8085f1c9987994e7!2sDehradun%2C%20Uttarakhand%20248001%2C%20India!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin',
};

export const STATS_DATA: StatCounter[] = [
  {
    label: 'Projects Delivered',
    value: 1220,
    suffix: '+',
    description: 'Complex books, journals, & educational series completed on schedule.',
  },
  {
    label: 'Happy Global Clients',
    value: 18,
    suffix: '+',
    description: 'Leading publishers, universities, and corporate institutions worldwide.',
  },
  {
    label: 'Pages Produced',
    value: 80,
    suffix: 'K+',
    description: 'Typeset, validated XML, and accessible PDF/EPUB pages created.',
  },
  {
    label: 'Years of Experience',
    value: 15,
    suffix: '+',
    description: 'Decades of domain mastery in typesetting, prepress, and automation.',
  },
];

export const SERVICES_DATA: ServiceItem[] = [
  {
    id: 'adobe-cc',
    category: 'adobe',
    categoryLabel: 'Adobe Creative Cloud',
    title: 'Adobe Creative Cloud Services',
    iconName: 'Layout',
    tagline: 'Precision Typesetting & Graphic Design',
    description: 'Comprehensive design, page composition, and prepress typesetting using Adobe InDesign, Photoshop, and Illustrator for K-12, higher education, academic journals, and corporate titles.',
    features: [
      'Adobe InDesign Typesetting & Master Grid Design',
      'Strict Hyphenation & Justification (H&J) Rules (No Hyphen Stacks)',
      '100% Widow, Orphan & Runover Line Elimination',
      'Baseline Grid Snapping & Optical Margin Alignment (Hanging Punctuation)',
      'Artwork Recreation & Technical Vector Illustration',
      'Complex Math & LaTeX Equation Formatting',
      'Interactive PDF Generation with Form Fields'
    ],
    deliverables: [
      'Print-ready PDF/X-1a & PDF/X-4',
      'Packaged InDesign Source (.INDD)',
      'High-res Vector Graphics (.AI, .EPS)',
      'Fonts & Linked Assets Package'
    ],
    badge: 'Core Expertise',
    popular: true
  },
  {
    id: 'xml-epub',
    category: 'xml',
    categoryLabel: 'XML & EPUB',
    title: 'XML & EPUB Digital Publishing',
    iconName: 'FileCode',
    tagline: 'Multi-Format Content Transformation',
    description: 'Seamless content structuring and conversion into standard XML schemas (JATS, BITS, DocBook, TEI) and responsive EPUB 3 (Reflowable and Fixed Layout) for global distribution.',
    features: [
      'High-Precision XML Conversion & DTD Validation',
      'EPUB 3.2 Reflowable & Fixed Layout Creation',
      'HTML5 Interactive Module Development',
      'Digital Publishing & E‑Book Packaging',
      'Rich Metadata Enrichment & CrossRef Indexing'
    ],
    deliverables: [
      'Validated XML Files with DTD/XSD',
      'ePubCheck Certified .EPUB Files',
      'Mobi/Kindle Formats',
      'ONIX 3.0 Metadata Files'
    ],
    badge: 'Automation Driven'
  },
  {
    id: 'editorial',
    category: 'editorial',
    categoryLabel: 'Copy Editing',
    title: 'Copy Editing & Academic Editorial',
    iconName: 'Edit3',
    tagline: 'Flawless Language & Style Consistency',
    description: 'Expert editorial services by experienced subject-matter editors. We refine grammar, tone, clarity, and ensure rigorous adherence to style guides like APA, Chicago, MLA, and ACS.',
    features: [
      'Substantive Copy Editing & Proofreading',
      'Rigorous Grammar & Syntax Enhancement',
      'Style Guide Compliance (APA, Chicago, MLA, Harvard)',
      'Academic & Technical Journal Editorial Review',
      'Bibliography & Reference Verification'
    ],
    deliverables: [
      'Word Documents with Track Changes',
      'Clean Final Manuscripts',
      'Custom Style Sheets & Glossaries',
      'Editorial Query Log'
    ]
  },
  {
    id: 'accessibility',
    category: 'accessibility',
    categoryLabel: 'Accessibility',
    title: 'Accessibility (PDF/UA & WCAG 2.1 AA)',
    iconName: 'Eye',
    tagline: '100% Screen-Reader Ready Digital Documents',
    description: 'Transforming PDFs, Word documents, and EPUBs into fully compliant accessible assets adhering to WCAG 2.1 AA, Section 508, and PDF/UA specifications for inclusive education.',
    features: [
      'Accessible PDF Tagging & Reading Order Structuring',
      'Accessible Word Template & Document Remediation',
      'PDF/UA & WCAG 2.1 AA Full Audit & Compliance',
      'Screen Reader Optimization (NVDA, JAWS, VoiceOver)',
      'Detailed Alternative Text (Alt-Text) Writing for Complex Diagrams'
    ],
    deliverables: [
      'PAC 2021 Compliant PDF/UA Files',
      'VPAT (Voluntary Product Accessibility Template)',
      'Accessibility Audit Certification Report',
      'Alt-Text Companion Log'
    ],
    badge: '100% Compliant',
    popular: true
  },
  {
    id: 'ocr-formatting',
    category: 'ocr',
    categoryLabel: 'OCR & Formatting',
    title: 'OCR & Document Formatting',
    iconName: 'FileText',
    tagline: 'Legacy Content Digitization & Cleanup',
    description: 'Converting legacy print materials, scanned archives, and raw manuscript drafts into clean, editable digital Word formats with perfect typography, template styling, and table formatting.',
    features: [
      'High-Accuracy OCR Conversion & Manual Proof-Verification',
      'Microsoft Word Advanced Template Styling & Cleanup',
      'Complex Mathematical Equation Formatting (MathType/LaTeX)',
      'Multi-Column & Multi-Language Document Restoration',
      'Table Restructuring & Data Layout Alignment'
    ],
    deliverables: [
      'Clean Structured MS Word (.DOCX)',
      'MathType / LaTeX Equation Files',
      'Searchable Text PDF',
      'Quality Discrepancy Log'
    ]
  },
  {
    id: 'web-development',
    category: 'webdev',
    categoryLabel: 'Web Development',
    title: 'Web Development Expertise & Portals',
    iconName: 'Globe',
    tagline: 'Custom Web Apps, Publisher Portals & E‑Learning Solutions',
    description: 'Full-stack enterprise web development specializing in custom publisher portals, author manuscript submission platforms, interactive e‑learning web applications, CMS platforms, responsive web interfaces, and automated pipeline integrations built with modern frameworks like React, Next.js, Node.js, and Cloud infrastructures.',
    features: [
      'Custom Enterprise Web App & Portal Development (React, Next.js, Node.js)',
      'Publisher & Author Submission Workflow Portals',
      'Responsive E‑Learning & Interactive Content Web Interfaces',
      'REST API & Microservices Integration for Automated Prepress Pipelines',
      'Cloud Database Integration, User Authentication & CMS Platforms',
      'SEO-Optimized, High-Speed Performance & Modern Responsive UI/UX Design'
    ],
    deliverables: [
      'Full Source Code Repository & Production Build Package',
      'Interactive Web Application Portal & Admin Dashboard',
      'RESTful API Endpoints & Integration Documentation',
      'Cloud Deployment & Automated CI/CD Setup'
    ],
    badge: 'New Service',
    popular: true
  }
];

export const WORKFLOW_STEPS: WorkflowStep[] = [
  {
    stepNumber: 1,
    title: 'Client Requirement',
    shortDesc: 'Scope Intake & File Audit',
    fullDesc: 'We receive manuscripts, design briefs, or legacy assets, performing automated structural audits to determine optimal workflows.',
    iconName: 'FileSearch',
    sla: 'Within 2 Hours',
    aiEnhancement: 'AI Pre-Flight File Analysis & Font/Asset Extraction',
    qualityGate: 'Completeness Verification'
  },
  {
    stepNumber: 2,
    title: 'Project Analysis',
    shortDesc: 'Resource & Spec Mapping',
    fullDesc: 'Our technical team analyzes DTD rules, styling guidelines, accessibility thresholds, and page layout grid specifications.',
    iconName: 'BarChart2',
    sla: 'Within 4 Hours',
    aiEnhancement: 'Automated Style Guide & DTD Schema Matching',
    qualityGate: 'Specification Sign-Off'
  },
  {
    stepNumber: 3,
    title: 'Project Planning',
    shortDesc: 'Milestones & Template Prep',
    fullDesc: 'Custom InDesign master pages, Word styles, or XML conversion scripts are configured for rapid batch processing.',
    iconName: 'Calendar',
    sla: 'Day 1',
    aiEnhancement: 'Smart Master Page & Grid Generator',
    qualityGate: 'Sample Chapter Approval'
  },
  {
    stepNumber: 4,
    title: 'Production',
    shortDesc: 'AI-Assisted Typesetting & Conversion',
    fullDesc: 'Skilled compositors and automated conversion engines perform page composition, XML tagging, or PDF/UA remediation.',
    iconName: 'Cpu',
    sla: 'Agreed Batch Schedule',
    aiEnhancement: 'AI Layout Refinement & Auto-Hyphenation Balance',
    qualityGate: 'In-Process Quality Audits'
  },
  {
    stepNumber: 5,
    title: 'Quality Check',
    shortDesc: 'Rigorous Multi-Tier Validation',
    fullDesc: '100% proofing, ePubCheck certification, PAC 2021 accessibility testing, and DTD validation ensure zero defect delivery.',
    iconName: 'CheckCircle2',
    sla: 'Pre-Shipment Gate',
    aiEnhancement: 'Automated Visual Diff & XML DTD Validator',
    qualityGate: '100% Quality Sign-Off'
  },
  {
    stepNumber: 6,
    title: 'Client Review',
    shortDesc: 'Collaborative Proof Feedback',
    fullDesc: 'Proofs are delivered via secure digital review portals for publisher feedback, author corrections, or editorial approvals.',
    iconName: 'MessageSquare',
    sla: 'Client Driven',
    aiEnhancement: 'AI Delta Comparison for Revision Round Tracking',
    qualityGate: 'Correction Compliance'
  },
  {
    stepNumber: 7,
    title: 'Final Delivery',
    shortDesc: 'Archival & Press-Ready Assets',
    fullDesc: 'Final validated assets (PDF/X, INDD, EPUB, XML, Word) are packaged and delivered securely via cloud channels.',
    iconName: 'Send',
    sla: 'Instant On Approval',
    aiEnhancement: 'Automated Asset Packaging & Metadata Generation',
    qualityGate: 'Client Receipt Acknowledgment'
  }
];

export const WHY_CHOOSE_US = [
  {
    title: 'Experienced Expert Team',
    description: 'Over 15+ years of dedicated experience with seasoned typesetters, XML engineers, and certified WCAG accessibility specialists.',
    iconName: 'Users',
    stat: '15+ Yrs',
    highlight: 'Subject Matter Mastery'
  },
  {
    title: 'AI-Assisted Production',
    description: 'Combining human craftsmanship with intelligent automation engines to accelerate production speeds by up to 60%.',
    iconName: 'Sparkles',
    stat: '60% Faster',
    highlight: 'Intelligent Workflows'
  },
  {
    title: 'Rigorous Quality Assurance',
    description: 'Multi-layer quality gates guarantee 99.98% accuracy on typesetting, accessibility tags, and XML DTD validation.',
    iconName: 'ShieldCheck',
    stat: '99.98%',
    highlight: 'Zero-Defect Commitment'
  },
  {
    title: 'Fast Turnaround Times',
    description: 'Round-the-clock operations ensure rapid cycle times, enabling publishers to meet demanding editorial release dates.',
    iconName: 'Zap',
    stat: '24/7 Ops',
    highlight: 'Accelerated Delivery'
  },
  {
    title: 'Global Compliance Standards',
    description: 'Strict adherence to ISO 9001, PDF/UA, WCAG 2.1 AA, Section 508, JATS 1.3, and BITS standards for worldwide publishing.',
    iconName: 'Globe',
    stat: '100%',
    highlight: 'International Compliance'
  },
  {
    title: 'Dedicated Account Support',
    description: 'Personalized project managers assigned to every client to ensure clear communication, status reporting, and swift resolutions.',
    iconName: 'Headphones',
    stat: '< 15m Response',
    highlight: 'Concierge Service'
  }
];

export const TECHNOLOGIES: Technology[] = [
  { id: 'indesign', name: 'Adobe InDesign', category: 'adobe', icon: 'Layout', color: '#FF3366', description: 'Industry-standard page composition and typesetting tool.' },
  { id: 'illustrator', name: 'Adobe Illustrator', category: 'adobe', icon: 'PenTool', color: '#FF9900', description: 'Vector graphics and technical artwork recreation.' },
  { id: 'photoshop', name: 'Adobe Photoshop', category: 'adobe', icon: 'Image', color: '#31A8FF', description: 'High-end image processing and color management.' },
  { id: 'acrobat', name: 'Adobe Acrobat Pro', category: 'adobe', icon: 'FileText', color: '#ED2224', description: 'PDF creation, preflighting, and PDF/UA remediation.' },
  { id: 'xml', name: 'XML Schemas', category: 'publishing', icon: 'Code', color: '#0066CC', description: 'JATS, BITS, DocBook, TEI, and custom DTD conversion.' },
  { id: 'epub', name: 'EPUB 3.2', category: 'publishing', icon: 'BookOpen', color: '#00A86B', description: 'Reflowable & Fixed Layout digital e-book formatting.' },
  { id: 'word', name: 'MS Word Advanced', category: 'editorial', icon: 'File', color: '#2B579A', description: 'Template formatting, styles cleanup, and macros.' },
  { id: 'ai-tools', name: 'AI Production Tools', category: 'ai', icon: 'Cpu', color: '#8B5CF6', description: 'Intelligent layout balancing and automated quality checks.' },
  { id: 'ocr-engine', name: 'OCR Tech', category: 'publishing', icon: 'Scan', color: '#0284C7', description: 'High-speed character recognition for legacy archives.' },
  { id: 'pac', name: 'PAC 2021 & Screen Readers', category: 'accessibility', icon: 'Eye', color: '#10B981', description: 'PDF/UA verification with NVDA & JAWS testing.' },
  { id: 'web-dev-stack', name: 'Web Dev Stack', category: 'publishing', icon: 'Code', color: '#38BDF8', description: 'Custom web portals, e‑learning platforms, and cloud microservices.' }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    author: 'Dr. Marcus Vance',
    role: 'Editorial Director',
    company: 'Apex Academic Press',
    location: 'Boston, USA',
    avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
    rating: 5,
    quote: 'ASAP LEARNING transformed our academic journal workflow. Their XML conversion and InDesign typesetting reduced our issue production time from 3 weeks to 6 days with flawless quality.',
    serviceCategory: 'XML & Adobe Creative Cloud',
    impactMetric: '70% Cycle Time Reduction'
  },
  {
    id: '2',
    author: 'Claire Thornton',
    role: 'Head of Digital Content',
    company: 'Global Education Publishing',
    location: 'London, UK',
    avatarUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200',
    rating: 5,
    quote: 'The accessibility remediation provided by ASAP LEARNING is second to none. Over 2,000 PDF textbooks were converted to PDF/UA compliant assets with detailed alt-text in record time.',
    serviceCategory: 'Accessibility (PDF/UA & WCAG)',
    impactMetric: '2,000+ Textbooks Made Accessible'
  },
  {
    id: '3',
    author: 'Rajesh Kumar',
    role: 'Publishing Operations Manager',
    company: 'Horizon Higher Education',
    location: 'Singapore',
    avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
    rating: 5,
    quote: 'From complex artwork recreation to multi-column math typesetting in InDesign, the ASAP team consistently delivers press-ready files. Their AI-assisted workflow is a true game changer.',
    serviceCategory: 'Typesetting & Artwork',
    impactMetric: '100% On-Time Press Delivery'
  }
];

export interface DomainCapabilitySpec {
  id: string;
  subTitle: string;
  scopeDescription: string;
  technicalCapabilities: string[];
  outputDeliverables: string[];
  qualityStandards: string[];
  softwareStack: string[];
  slaBenchmark: string;
}

export interface DomainCategoryData {
  id: 'higher-education' | 'k12-education' | 'interactive-accessibility';
  title: string;
  shortTitle: string;
  tagline: string;
  iconName: string;
  badge: string;
  volumeCapacity: string;
  slaBenchmark: string;
  qualityStandard: string;
  accentColor: string;
  gradientBg: string;
  specifications: DomainCapabilitySpec[];
}

export const PUBLISHING_DOMAINS_DATA: DomainCategoryData[] = [
  {
    id: 'higher-education',
    title: 'Higher Education Publishing',
    shortTitle: 'Higher Ed',
    tagline: 'University Press Publications, Academic Research Journals, Higher-Ed Courseware & STEM Math Composition',
    iconName: 'GraduationCap',
    badge: 'University & STM Publishing Solutions',
    volumeCapacity: '15,000+ Pages Processed / Month',
    slaBenchmark: '99.98% DTD & Math Accuracy SLA',
    qualityStandard: 'ISO 9001:2015 & JATS/BITS Compliant',
    accentColor: 'text-blue-400 border-blue-500/30 bg-blue-500/10',
    gradientBg: 'from-blue-600/20 via-indigo-600/10 to-transparent',
    specifications: [
      {
        id: 'he-spec-1',
        subTitle: 'University Press & STM Journal Composition',
        scopeDescription: 'End-to-end typesetting and XML transformation for academic research journals, peer-reviewed monographs, and university press releases.',
        technicalCapabilities: [
          'JATS 1.3 & BITS 2.1 XML Automated Extraction',
          'MathType & LaTeX Equation Layout Balancing',
          'Multi-Column Grid Composition in Adobe InDesign',
          'Crossref & PubMed Central (PMC) Metadata Tagging'
        ],
        outputDeliverables: [
          'Press-Ready PDF/X-1a and PDF/X-4 Packages',
          'JATS 1.3 & BITS 2.1 XML Archival Packages',
          'MathType & LaTeX Raw Formula Source Files',
          'Crossref Structured DOI XML Records'
        ],
        qualityStandards: [
          '99.98% DTD Schema Validation Accuracy',
          '100% Citation Cross-Link Verification',
          'Automated Preflighting & Press Proofing'
        ],
        softwareStack: ['Adobe InDesign CC', 'JATS/BITS XML Engine', 'MathType', 'LaTeX', 'Crossref DTD'],
        slaBenchmark: '70% Faster Turnaround vs Traditional Production'
      },
      {
        id: 'he-spec-2',
        subTitle: 'College & Higher-Ed Courseware Production',
        scopeDescription: 'Complex multi-author college textbooks with dense graphics, vector diagrams, multi-level indexing, and interactive digital editions.',
        technicalCapabilities: [
          'Dense Multi-Column Page Composition',
          'Vector Artwork Recreation & High-Res Redrawing',
          'Automated Subject Indexing & Glossary Linking',
          'Interactive Campus LMS PDF Generation'
        ],
        outputDeliverables: [
          'Master Adobe InDesign (.INDD) Packages',
          'High-Resolution Vector Graphics (.AI / .EPS)',
          'Interactive College PDF with Hyperlinks',
          'Structured Word DOCX Source Backups'
        ],
        qualityStandards: [
          '100% Press Safety Margin Alignment',
          'RGB to CMYK Professional Color Profiles',
          'High-Resolution 300+ DPI Asset Audit'
        ],
        softwareStack: ['InDesign CC', 'Illustrator CC', 'Photoshop CC', 'Acrobat Pro', 'ePubCheck'],
        slaBenchmark: 'Zero-Defect On-Time Press Delivery SLA'
      },
      {
        id: 'he-spec-3',
        subTitle: 'Legacy Journal Backfile Digitization & Archive Conversion',
        scopeDescription: 'Digitization and XML tagging of historic academic archives, converting printed backfiles into searchable digital repositories.',
        technicalCapabilities: [
          'High-Speed Multi-Language OCR Scanning',
          'Retro-Tagging to JATS 1.3 XML Standards',
          'Header/Footer & Artifact Clean-Up',
          'JSTOR & PubMed Central Schema Compliance'
        ],
        outputDeliverables: [
          'Structured JATS XML Repositories',
          'Searchable OCR-Enhanced PDF Archives',
          'PubMed Central Deposit Packages'
        ],
        qualityStandards: [
          'Double-Key Data Entry Integrity Validation',
          'Schema DTD Structural Integrity Guarantee'
        ],
        softwareStack: ['Enterprise OCR Engine', 'JATS XML Parser', 'DocBook Engine', 'PubMed DTD Tool'],
        slaBenchmark: 'Massive Batch Scalability (10,000+ Pages/Month)'
      }
    ]
  },
  {
    id: 'k12-education',
    title: 'Children Education K-12',
    shortTitle: 'Children K-12',
    tagline: 'Primary & Secondary Textbooks, Early Childhood Workbooks, Vector Artwork & Teacher Guides',
    iconName: 'BookOpen',
    badge: 'K-12 School & Early Learning Solutions',
    volumeCapacity: '1,200+ Workbooks Processed / Term',
    slaBenchmark: '100% Curriculum Grid & Safety Margin Alignment',
    qualityStandard: 'Strict Child-Friendly Layout Standards',
    accentColor: 'text-purple-400 border-purple-500/30 bg-purple-500/10',
    gradientBg: 'from-purple-600/20 via-pink-600/10 to-transparent',
    specifications: [
      {
        id: 'k12-spec-1',
        subTitle: 'Primary & Early Childhood Activity Workbooks',
        scopeDescription: 'Vibrant activity books, phonics readers, and primary STEM workbooks featuring custom vector illustrations, child-friendly typography, and precise grid layouts.',
        technicalCapabilities: [
          'Custom Vector Artwork & Character Creation',
          'Vibrant Large-Font Page Layout & Grid Balance',
          'Teacher Edition Answer Key Overlay Formatting',
          'Color Separation for High-Speed Web Press'
        ],
        outputDeliverables: [
          'InDesign Master Production Packages',
          'Print-Ready PDF/X-1a Files',
          'Editable Vector EPS & AI Artwork Assets',
          'Interactive Digital Student PDFs'
        ],
        qualityStandards: [
          'Child-Friendly Typography Legibility Protocols',
          'Flawless Color Bleed & Trim Line Safety',
          'Strict Color Separation for Mass Print'
        ],
        softwareStack: ['Adobe InDesign CC', 'Adobe Illustrator CC', 'Photoshop CC', 'Color Management Suite'],
        slaBenchmark: 'Over 350 Titles Processed Per Term'
      },
      {
        id: 'k12-spec-2',
        subTitle: 'Secondary School Science & Mathematics Textbooks',
        scopeDescription: 'Middle and High School STEM curriculum materials with precise scientific vector diagrams, multi-column layouts, and teacher edition guides.',
        technicalCapabilities: [
          'Scientific & Technical Vector Diagram Redrawing',
          'Multi-Column Layouts with Integrated Formulas',
          'Comprehensive Glossary & Subject Indexing',
          'Dual-Language & Multi-Region Adaptation'
        ],
        outputDeliverables: [
          'Press-Ready PDF/X-4 High-Resolution Files',
          'Digital Annotated Student PDFs',
          'AI & EPS Vector Diagram Repositories'
        ],
        qualityStandards: [
          '100% Curriculum Standard Alignment',
          'Scientific Symbol & Formula Accuracy Guarantee'
        ],
        softwareStack: ['InDesign CC', 'Illustrator CC', 'MathType', 'Acrobat Pro'],
        slaBenchmark: 'Flexible Fast-Track Turnaround for School Terms'
      }
    ]
  },
  {
    id: 'interactive-accessibility',
    title: 'Interactive & Accessibility',
    shortTitle: 'Interactive & Accessibility',
    tagline: 'PDF/UA (ISO 14289-1) & WCAG 2.1 AA Remediation, EPUB3 Reflowable & Fixed Layout with Read-Aloud SMIL Audio',
    iconName: 'ShieldCheck',
    badge: 'PDF/UA & WCAG 2.1 AA Certified',
    volumeCapacity: '2,500+ Documents Remediated',
    slaBenchmark: '100% PAC 2021 Automated Audit Pass',
    qualityStandard: 'ISO 14289-1, WCAG 2.1 AA, Section 508',
    accentColor: 'text-emerald-400 border-emerald-500/30 bg-emerald-500/10',
    gradientBg: 'from-emerald-600/20 via-teal-600/10 to-transparent',
    specifications: [
      {
        id: 'ia-spec-1',
        subTitle: 'Enterprise PDF/UA & WCAG 2.1 AA Remediation',
        scopeDescription: 'Comprehensive document remediation turning standard PDFs into fully accessible PDF/UA (ISO 14289-1) compliant files for screen readers.',
        technicalCapabilities: [
          'Logical Document Structure & Heading Tree Tagging',
          'Comprehensive Alt-Text Authoring for Complex Charts',
          'Complex Data Table Tagging & Headers Mapping',
          'Screen Reader Validation (NVDA, JAWS, VoiceOver)'
        ],
        outputDeliverables: [
          'Certified Accessible PDF/UA Files',
          'PAC 2021 Automated Compliance Audit Reports',
          'Alt-Text Repository Documentation Logs',
          'Section 508 VPAT Certificate Documentation'
        ],
        qualityStandards: [
          'Zero PAC 2021 PDF/UA Syntax Violations',
          '100% Manual Human Screen Reader Audit Verification',
          'WCAG 2.1 Level AA Contrast & Focus Order Pass'
        ],
        softwareStack: ['Adobe Acrobat Pro', 'PAC 2021 Checker', 'NVDA Reader', 'JAWS', 'VoiceOver'],
        slaBenchmark: 'Guaranteed 100% Compliance Certification'
      },
      {
        id: 'ia-spec-2',
        subTitle: 'EPUB3 Reflowable / Fixed Layout & Read-Aloud SMIL',
        scopeDescription: 'Advanced digital e-book formatting with synchronized read-aloud media overlays, interactive quizzes, and cross-platform e-reader optimization.',
        technicalCapabilities: [
          'EPUB 3.2 Reflowable & Fixed Layout Development',
          'SMIL Audio Synchronization for Read-Aloud Media',
          'Interactive HTML5/CSS3 Quizzes & Overlays',
          'Accessibility Metadata & ARIA Landmark Tagging'
        ],
        outputDeliverables: [
          'ePubCheck 4.2 Valid EPUB3 Packages',
          'Synchronized SMIL Audio Overlays',
          'High-Contrast Responsive Digital Assets'
        ],
        qualityStandards: [
          '100% European Accessibility Act (EAA) Compliance',
          'Cross-Platform Validation (Apple Books, Kindle, Kobo)'
        ],
        softwareStack: ['EPUB 3.2 Engine', 'SMIL Audio Tool', 'HTML5/CSS3', 'ePubCheck', 'Readium'],
        slaBenchmark: 'Complete E-Reader Compatibility Guarantee'
      }
    ]
  }
];


export const FAQS = [
  {
    q: 'What types of publishing projects does ASAP LEARNING specialize in?',
    a: 'We specialize in K-12 and Higher Education textbooks, academic journals, corporate documents, reference books, digital e-books (EPUB 3), and accessible digital publishing assets (PDF/UA).'
  },
  {
    q: 'How does your AI-Assisted Workflow improve turnaround times?',
    a: 'We combine human domain expertise with custom AI scripts for automated styling, pre-flight file checks, XML DTD validation, and layout balancing, accelerating turnaround by up to 60% while maintaining 99.98% accuracy.'
  },
  {
    q: 'What accessibility standards do you adhere to?',
    a: 'Our remediation team guarantees full compliance with PDF/UA (ISO 14289-1), WCAG 2.1 Level AA, and Section 508 guidelines, verified using PAC 2021 and tested on NVDA, JAWS, and VoiceOver screen readers.'
  },
  {
    q: 'Can you handle large batch conversions or rush deadlines?',
    a: 'Yes! With round-the-clock operations and scalable production units in Dehradun, India, we comfortably process tens of thousands of pages per month with flexible expedited delivery options.'
  },
  {
    q: 'How do I request a sample or a custom project quote?',
    a: 'You can fill out our interactive Contact / Instant Quote form on this website or reach out directly to info@asaplearning.com or call +91-7817899559. We typically provide sample conversions within 24 hours.'
  }
];
